(() => {
  angular
    .module('complianceFrameworkApp.complianceFramework')
    .factory('authenticationService', authenticationService);

  /* ngInject */
  function authenticationService($resource, config) {
    let url = `${config.complianceFrameworkApiEndpoint}/api/sessions`;
    let paramDefaults = {};
    let headers = authToken => ({'Authorization': 'Token token=' + authToken});

    let actions = authToken => (        
      {
        'authenticate': {
          url: `${url}/verify`,
          method: 'POST', 
          headers: headers(authToken)
        },
        'authenticateWithPassword': {
          method: 'POST',
          headers: headers(authToken)
        },
        'logOut': {
          method: 'DELETE',
          url: `${config.complianceFrameworkApiEndpoint}/api/logout`,
          headers: headers(authToken)
        }
      });
    
    return authToken => $resource(url, paramDefaults, actions(authToken));
  }
})();
